import { FormInstance, message } from "antd";

export interface IOnConfirmDrawerUpdateTag {
  formEdit: FormInstance<any>;
  tagIdSelected: number;
  isTagActive: boolean;
  messageDescription: string;
  tagsUpdateTagAsync: (...args) => void;
}

export const onConfirmDrawerUpdateTag = async ({ formEdit, tagIdSelected, isTagActive, tagsUpdateTagAsync, messageDescription }: IOnConfirmDrawerUpdateTag) => {
  try {
    await formEdit.validateFields();
    const vehiclePlate = formEdit.getFieldValue("vehiclePlate");

    const bodyRequest = {
      id: tagIdSelected,
      vehiclePlate,
      status: isTagActive ? 1 : 0,
    };

    tagsUpdateTagAsync(bodyRequest);
  } catch (e) {
    message.error(messageDescription);
  }
  return true;
};
